/* global axios */
import ApiClient from '../ApiClient';

// Bulk actions repeat the listing's filters so the server can resolve
// "select all" against exactly what the user is looking at.
const filterPayload = ({
  searchKey,
  assistantId,
  documentType,
  contentStatus,
} = {}) => ({
  searchKey,
  assistant_id: assistantId,
  documentType,
  contentStatus,
});

class CaptainDocument extends ApiClient {
  constructor() {
    super('captain/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, documentType, contentStatus } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
        assistant_id: assistantId,
        documentType,
        contentStatus,
      },
    });
  }

  extractContent(id) {
    return axios.post(`${this.url}/${id}/extract_content`);
  }

  // `all` asks the server to act on everything matching the current filters
  // rather than on a list of ids, so selecting 800 documents does not mean
  // shipping 800 ids up the wire.
  bulkDestroy({ ids, all, filters = {} } = {}) {
    return axios.post(`${this.url}/bulk_destroy`, {
      ids,
      all,
      ...filterPayload(filters),
    });
  }

  bulkExtractContent({ ids, all, filters = {} } = {}) {
    return axios.post(`${this.url}/bulk_extract_content`, {
      ids,
      all,
      ...filterPayload(filters),
    });
  }
}

export default new CaptainDocument();
